// Ephemeral hosts (<developer>.<stage host>) let CloudFront pick each remote's build per
// app, which only works if remotes load from the page's host rather than the absolute one.
export function rebaseRemotesOntoPageHost(
  manifest: Record<string, string>,
  page: Pick<Location, 'hostname' | 'origin'>,
): Record<string, string> {
  const rebased: Record<string, string> = {};
  for (const [name, url] of Object.entries(manifest)) {
    rebased[name] = rebase(url, page);
  }
  return rebased;
}

function rebase(url: string, page: Pick<Location, 'hostname' | 'origin'>): string {
  let remote: URL;
  try {
    remote = new URL(url);
  } catch {
    return url;
  }
  if (!page.hostname.endsWith(`.${remote.hostname}`)) {
    return url;
  }
  return `${page.origin}${remote.pathname}${remote.search}${remote.hash}`;
}
